export default "__VITE_PUBLIC_ASSET__5ed9d784__"